import React, { useCallback, useEffect } from "react";
import { observer } from "mobx-react-lite";

import { translationService } from "../../../services/translation/TranslationService";
import useThemService from "../../../services/theme-service/ThemeService";
import { Error } from "../../svg/svgImageList";
import useModal from "../../dialog/useModal";
import { Dialog } from "../../dialog/Dialog";

interface ErrorModalProps {
  titleKey: string;
  messageKey: string;
  errorElement?: React.JSX.Element;
  onClose?: () => void;
}

export default observer(function ErrorModal(props: ErrorModalProps) {
  const { titleKey, messageKey, onClose, errorElement } = props;

  const { themeClass } = useThemService();

  const { isVisible, toggleModal } = useModal();

  const closeModal = useCallback(() => {
    if (onClose) {
      onClose();
    }
    toggleModal();
  }, [onClose, toggleModal]);

  useEffect(() => {
    toggleModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog
      isVisible={isVisible}
      onHide={closeModal}
      titleKey={titleKey}
      buttonCancel={{
        textKey: "general.ok",
        action: closeModal,
      }}
      iconTitle={{
        svg: Error,
        className: themeClass(["icon-error"]),
        width: 30,
        height: 30,
      }}
    >
      {errorElement !== undefined ? (
        errorElement
      ) : (
        <div>{translationService.translate(messageKey)}</div>
      )}
    </Dialog>
  );
});
